import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const typeCallSlice = createSlice({
    name:'typeCall',
    initialState,
    reducers: {
        loadListTypeCallState: (state, payload) => { 
            return payload.payload
         }
    }
})

export const { loadListTypeCallState } = typeCallSlice.actions;

const { reducer } = typeCallSlice;

export default reducer;